import { useEffect } from "react"

export function useObserve(ref, callback) {
    useEffect(() => {
        if (ref.current == null) return;
        callback();
        const observer = new ResizeObserver(() => callback());
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [ref.current]);
}